import { render, staticRenderFns } from "./AddressSimple.vue?vue&type=template&id=3be08836&scoped=true&"
import script from "./AddressSimple.vue?vue&type=script&lang=js&"
export * from "./AddressSimple.vue?vue&type=script&lang=js&"
import style0 from "./AddressSimple.vue?vue&type=style&index=0&id=3be08836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be08836",
  null
  
)

export default component.exports